export default () => {
  $('button.hamburguer-icon').off('click').click(function () {
    if (!$(this).hasClass('open') && $('.cont-options').hasClass('active')) {
      $('.cont-options').removeClass('active');
      $('.fal.fa-chevron-down').removeClass('active');
    }
    $(this).toggleClass('open');
  });
}
